(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@qcharts/core/lib/index.js"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@qcharts/core/lib/index.js", "react"], factory);
	else if(typeof exports === 'object')
		exports["QchartsReact"] = factory(require("@qcharts/core/lib/index.js"), require("react"));
	else
		root["QchartsReact"] = factory(root["qcharts"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 